import axios from "axios";

export default async function filterInProgressDocuments(projectName, formName, data){
    const res = await axios.post(`/project/${projectName}/${formName}/research-document-in-progress`, data,  { responseType: "blob" });
    return res
}